export const TIME_ENTRY_WIDTH_PX = 200;
export const TIMESPAN_WIDTH_PX = 40;
export const TIMESPAN_SPACING_PX = 20;
export const DEFAULT_MEMORY_COLOR = 'rgba(0,0,0,.12)';
